import { Construction } from "lucide-react";
import { ReactNode } from "react";

export default function ErrorPage({
  children,
}: Readonly<{ children: ReactNode }>) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <Construction size={64} className="text-primary stroke-1" />
      <p>{children}</p>
    </div>
  );
}
